import { container } from 'tsyringe';

import { CoursesListGateway } from '@/application/interfaces/course-list.interface';
import { EventTracker } from '@/application/interfaces/event-tracker.interface';
import { UserMicrocertificateGateway } from '@/application/interfaces/user-microcertificate.interface';

import { FlowpressCoursesListGateway } from '../gateways/flowpress-course-details/flowpress-course-details.gateway';
import { PepeLegalUserMicrocertificateGateway } from '../gateways/pepe-legal-user-microcertificate/pepe-legal-user-microcertificate.gateway';
import { PocketEventTracker } from '../gateways/pocket-event-tracker/pocket-event-tracker.adapter';

container.register<EventTracker>('EventTracker', PocketEventTracker);

container.register<CoursesListGateway>(
  'CoursesListGateway',
  FlowpressCoursesListGateway,
);

container.register<UserMicrocertificateGateway>(
  'UserMicrocertificateGateway',
  PepeLegalUserMicrocertificateGateway,
);
